export default class Newsletter {
    constructor(node) {
        this.node = node;
        this.newsletterFormNode = this.node.querySelector('#frm-newsletter');
        
        this.settings = window.newsletterSettings;

        this.addListeners();
    }

    static init() {
        let newsletterNode = document.querySelector("[data-newsletter]");

        if (newsletterNode) {
            return new Newsletter(newsletterNode);
        }
    }

    addListeners() {
        let _this = this;
        
        $(this.newsletterFormNode).validate({
            callbackHandler: function (data, form)
            {
                _this.newsletterFormNode.querySelector('.response-text').innerHTML = data.d.HTML;
                if (data.d.Status)
                    _this.newsletterFormNode.querySelector('input[type="submit"]').style.display = 'none';
            }
        });
    }
}